module.exports = __webpack_public_path__ + "media/2.b8c4b027.mp3";